export default __webpack_public_path__ + "static/media/settings-icon.7ea68639.svg";